import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: {
      Component: FDHeadlineText, size: 'lg', color: 'textSecondary', align: 'center',
    },
  }, overrideReadOnly);
